import { ColumnType } from 'src/app/shared/enums/column-type';

export const PRIMARY: number = 1;
export const SECONDARY: number = 2;

export const OTHER: number = 3;

// TODO: maybe we should create a global constants file for these values
export const YES: string = 'Yes';
export const NO: string = 'No';

// The below variables are defined in the docType enum file
export const RMACTP: string = 'RMACTP';
export const RMACP: string = 'RMACP';
export const RRR: string = 'RRR';

export const FILES_LIST: string = 'filesList';

export interface CreateSHM {
  kTweleveList: {
    generate: SHMForms[];
    readOnly: SHMForms[];
    recipitentInfo: SHMForms;
    showCheck?: boolean;
  };
  preschoolList: {
    letterToParent: SHMForms;
    generate: SHMForms[];
    readOnly: SHMForms[];
    showCheck?: boolean;
  };
  week: string[];
  hqChoiceList: string[];
  vocationalNeedList: Controls[];
  independentLivingList: Controls[];
  LPList: LettersToParent[];
  PRACSites: PRACSites[];
}
export interface SHMForms {
  title: string;
  id: string;
  isEdit?: boolean;
  icon?: string;
  showCheck?: boolean;
}

export interface Controls {
  label: string;
  control: string;
}

export interface LettersToParent {
  heading: string;
  description: string;
}

export interface PRACSites {
  title: string;
  field: string;
  columnType: ColumnType;
}

export const CREATE_SHM_CONSTANTS: CreateSHM = {
  kTweleveList: {
    generate: [
      {
        title: 'Physical Examination Form',
        id: 'PEF',
        isEdit: true,
      },
      {
        title: 'Social History Evaluation',
        id: 'SHE',
        isEdit: true,
      },
      {
        title: 'Consent for Initial Evaluations',
        id: 'CIE',
        isEdit: true,
      },
      {
        title: 'Consent for Use of Electronic Email',
        id: 'CEM',
        isEdit: true,
      },
      {
        title: 'Home Language Identification Survey',
        id: 'HLIS',
        isEdit: true,
      },
      {
        title: 'Request for Release of Records',
        id: 'RRR',
        isEdit: true,
      },
      {
        title: 'Student Ethnicity Identification',
        id: 'SEI',
        isEdit: true,
      },
      {
        title:
          'Authorization for release of Health Information Pursuant to HIPAA',
        id: 'HIPAA',
        isEdit: true,
      },
      {
        title: 'Request for Medical Accommodations Completed by Parent',
        id: 'RMACP',
        isEdit: true,
      },
      {
        title:
          'Request for Medical Accommodations Completed by Treating Physician',
        id: 'RMACTP',
        isEdit: true,
      },
      {
        title: 'Level 1 Vocational Interview – Parent/Guardian',
        id: 'VI',
        isEdit: true,
      },
    ],
    readOnly: [
      {
        title: 'Procedural Safeguards Notice',
        id: 'PSN',
      },
    ],
    recipitentInfo: {
      title: 'Recipient Information',
      id: 'RINFO',
    },
  },
  preschoolList: {
    letterToParent: {
      title: 'Letter to Parents',
      id: 'LP',
    },
    generate: [
      {
        title: 'Physical Examination Form',
        id: 'PEF',
        isEdit: true,
      },
      {
        title: 'Consent for Initial Evaluations',
        id: 'CIE',
        isEdit: true,
      },
      {
        title: 'Consent for Use of Electronic Email',
        id: 'CEM',
        isEdit: true,
      },
      {
        title: 'Social History Evaluation',
        id: 'SHE',
        isEdit: true,
      },
      {
        title: 'Home Language Identification Survey',
        id: 'HLIS',
        isEdit: true,
      },
      {
        title:
          'Authorization for release of Health Information Pursuant to HIPAA',
        id: 'HIPAA',
        isEdit: true,
      },
      {
        title: 'Temporary Housing Questionnaire',
        id: 'HQ',
        isEdit: true,
      },
      {
        title: 'Student Ethnicity Identification',
        id: 'SEI',
        isEdit: true,
      },
    ],
    readOnly: [
      {
        title: 'A Family Guide to Preschool Special Education Services',
        id: 'PSES',
        icon: 'filePdf',
      },
      {
        title: 'Early Childhood Education Options Flyer',
        id: 'ECEOF',
        icon: 'filePdf',
      },
      {
        title: 'Preschool Evaluation Agency List',
        id: 'PEAL',
        icon: '',
      },
      {
        title: 'Procedural Safeguards Notice',
        id: 'PSN',
        icon: 'filePdf',
      },
    ],
  },
  week: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
  hqChoiceList: [
    'Doubled Up - With another family or other person because of loss of housing or as a result of economic hardship',
    'Shelter - Emergency or transitional shelter',
    'Hotel/Motel - Living in what is NOT an emergency or transitional shelter and involves payment',
    'Other Temporary Living Situation - Trailer park, campground, car, park, public places, abandoned building, street, or any other inadequate living space',
    'Permanent Housing - Student who is living in a fixed, regular, and adequate housing situation',
  ],
  vocationalNeedList: [
    { label: 'Vocation School/Training', control: 'schoolVocational' },
    { label: 'College', control: 'collegeVocational' },
    { label: 'Seeking employment', control: 'employmentVocational' },
    { label: 'Other', control: 'otherVocational' },
  ],

  independentLivingList: [
    { label: 'Vocation School/TrainingClothing care', control: 'clothingCare' },
    { label: 'Meal preparation', control: 'mealPreparation' },
    { label: 'Hygiene/grooming', control: 'grooming' },
    { label: 'Travel training', control: 'travelTraining' },
    { label: 'Community awareness', control: 'communityAwareness' },
    { label: 'Financial management', control: 'financialManagement' },
    { label: 'Time management', control: 'timeManagement' },
    { label: 'Organization', control: 'organization' },
    { label: 'Getting along with others', control: 'gettingAlongWithOthers' },
    { label: 'Self-advocacy', control: 'selfAdvocacy' },
    { label: 'Household management', control: 'householdManagement' },
    { label: 'Health/first aid', control: 'firstAid' },
    { label: 'Consumer skills', control: 'consumerSkills' },
    { label: 'Interpersonal skills', control: 'interpersonalSkills' },
    { label: 'Safety', control: 'safety' },
    { label: 'Appropriate behavior', control: 'appropriateBehavior' },
    { label: 'Problem solving', control: 'problemSolving' },
  ],

  LPList: [
    {
      heading:
        'A Prior Written Notice (Notice of Recommendation) for Initial Evaluation.',
      description:
        'This form is required by the New York State Education Department. It gives a summary of the information in the other materials in the referral packet. This notice explains that your child’s Committee on Preschool Special Education (CPSE) is proposing to conduct an initial evaluation of your child to determine if your child is eligible to receive special education services. The notice has information about how you can choose a preschool evaluation site and what assessments will be conducted.',
    },
    {
      heading: 'Preschool Evaluation Agency List.',
      description:
        'You have the right to choose any evaluation site from the enclosed list. The site will conduct the evaluation at no cost to you. Please choose an agency that can finish the evaluation of your child within 20 school days from your first evaluation appointment.',
    },
    {
      heading: 'Consent for Initial Preschool Evaluation.',
      description:
        'Before any evaluations can begin, we will need your written consent. Enclosed is a consent form. Please bring it with you to the evaluation site, but do NOT sign it until after the evaluation site explains your rights to you.',
    },
    {
      heading: 'Consent for Use of Electronic Mail.',
      description:
        'A parent of a student with a disability may elect to receive prior written notices, procedural safeguards notices, and other required notifications by electronic mail (email). In order for school personnel to use the internet email system for the transmission of notices to you, a signed consent form must be on file.',
    },
    {
      heading: 'Physical Examination Form',
      description:
        'The physical examination is part of the initial evaluation, and the evaluation agency is responsible for arranging this examination at no cost to you. You may also have your child’s doctor complete this form and give it to the evaluation site once you have it. If your child is in a childcare or Pre-K program, you may ask the program for a copy of this form if it was completed within the past year.',
    },
    {
      heading: 'A Family Guide to Preschool Special Education Services',
      description:
        'This guide describes the services and supports available to preschool children and will help you understand your rights as the parent of a child who has been referred or identified as having an educational disability.',
    },
    {
      heading: 'Housing Questionnaire',
      description:
        'Students living in temporary housing have certain rights, including access to the same public education and services that are available to permanently housed students. The New York City Department of Education asks all families to complete a Housing Questionnaire to determine which students are living in temporary housing. The information you provide is confidential. Please bring this form to your first evaluation appointment.',
    },
    {
      heading: 'Early Childhood Education Options Flyer',
      description:
        'This flyer describes the early childhood education options available to preschoolers with and without disabilities.',
    },
    {
      heading: 'Procedural Safeguards Notice',
      description:
        'The law provides you with certain rights in connection with this referral. These rights are explained in the Procedural Safeguards Notice.',
    },
  ],

  PRACSites: [
    {
      title: 'CSE',
      field: 'cse',
      columnType: ColumnType.text,
    },
    {
      title: 'Borough',
      field: 'borough',
      columnType: ColumnType.text,
    },
    {
      title: 'Telephone',
      field: 'telephone',
      columnType: ColumnType.text,
    },
    {
      title: 'Fax',
      field: 'fax',
      columnType: ColumnType.date,
    },
  ],
};

export const controlsToDisable: string[] = [
  'NameOfPersonInterviewed',
  'RelationshipToStudent',
  'languageOfInterview',
  'ReasonForReferral',
  'ReasonForReferralOther',
  'Others',
  'MedicalAlerts',
  'DevelopmentalHistory',
  'HealthMedicalBackground',
  'FamilyComposition',
  'StudentsBehaviorAtHome',
  'EducationalBackground',
  'ParentsViewOfSchoolPerformance',
  'SchoolPerformance',
  'RecreationInterests',
  'DueProcessConsent',
  'Summary',
  'DateOfReport',
  'EvaluatorName',
  'Telephone',
  'NYSLicense',
  'Discipline',
  'ProviderType',
  'Language',
  'Affirmation',
  'filesListSHE',
];
